<p-table [value]="reportLines" (onEditInit)="startEdit($event)" (onEditComplete)="onEditComplete($event)">
  <ng-template pTemplate="header">
    <tr>
      <th class="id-cell">#</th>
      <th class="material-table-cell">Name</th>
      <th>Quantity</th>
      <th>Price</th>
      <th>Total Price</th>
      <th class="delete-cell"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td class="id-cell">
        {{rowData.number}}
      </td>

      <td class="material-table-cell cab-name-cell" (click)="clickOnCab(rowData.name)" *ngIf="!rowData.editable"
          [ngClass]="{'clickable-field': clickableSet.has(rowData.name)}">
        {{rowData.name}}
      </td>

      <td pEditableColumn class="editable-cell name-cell" *ngIf="rowData.editable">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="string" class="material-input-text" [(ngModel)]="rowData.name">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.name}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td *ngIf="!rowData.editable" class="num-cell">
        {{rowData.qty | number: '1.2-2'}}
      </td>
      <td pEditableColumn class="editable-cell num-cell" *ngIf="rowData.editable">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text" [(ngModel)]="rowData.qty">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.qty | number: '1.2-2'}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td *ngIf="!rowData.editable" class="num-cell">
        {{rowData.price | number: '1.2-2'}}
      </td>
      <td pEditableColumn class="editable-cell num-cell" *ngIf="rowData.editable">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text" [(ngModel)]="rowData.price">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.price | number: '1.2-2'}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td>
        {{rowData.totalPrice | number: '1.2-2'}}
      </td>

      <td class="delete-cell deletable" (click)="deleteLine(rowData.number)" *ngIf="rowData.editable">
        <i class="pi pi-trash" style="font-size: 100%"></i>
      </td>

      <td class="delete-cell" *ngIf="!rowData.editable">

      </td>
    </tr>
  </ng-template>
</p-table>
<div class="table-footer-buttons">
  <button mat-button class="add-line-button" (click)="addItem()">
    <mat-icon>add</mat-icon>
    <div class="button-title">Add Line</div>
  </button>
</div>
